export default __webpack_public_path__ + "static/media/recipe-app.b1d51bfb.jpg";